import { FC, ReactElement } from 'react';

import { HStack, Text } from '@bonusly/design-system';

type IconAndTextContentProps = {
	icon: ReactElement;
	label: string;
	isExpanded: boolean;
};

export const IconAndTextContent: FC<IconAndTextContentProps> = ({ icon, label, isExpanded }) => (
	<HStack justifyContent="flex-start" alignItems="center" spacing={3}>
		{icon}
		<Text
			fontSize={100}
			fontWeight="medium"
			whiteSpace="nowrap"
			opacity={isExpanded ? 1 : 0}
			transition={isExpanded ? 'opacity 0.15s 0.075s linear' : 'opacity 0.15s cubic-bezier(.4, 0, .2, 1)'}
		>
			{label}
		</Text>
	</HStack>
);
